<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="TOC_Contents"><span epub:type="pagebreak" id="pagexi" title="xi"></span></p>
<p class="TOC_1exer" id="_idParaDest-4"><a id="_idTextAnchor001"></a>Exercises</p>
<p class="TOC_chpt"><a href="#/WFI#_idTextAnchor004">Understanding the Breath</a></p>
<p class="TOC_chpt"><a href="#/WFI1#_idTextAnchor009">Spatial Awareness</a> </p>
<p class="TOC_chpt"><a href="#/WFI2#_idTextAnchor012">Reaching the Divine</a> </p>
<p class="TOC_chpt"><a href="#/WFI3#_idTextAnchor016">The World Tree Within</a> </p>
<p class="TOC_chpt"><a href="#/WFI4#_idTextAnchor019">Calming the Sea and Sky</a> </p>
<p class="TOC_chpt"><a href="#/WFI5#_idTextAnchor026">Breathing the Runes</a> </p>
<p class="TOC_chpt"><a href="#/WFI6#_idTextAnchor029">Going to the Wells</a> </p>
<p class="TOC_chpt"><a href="#/WFI7#_idTextAnchor034">Community Expectations</a> </p>
<p class="TOC_chpt _idGenParaOverride-1"><a href="#/WFI8#_idTextAnchor037">Engaging with Sources</a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Exer.vue?2db75916